export default __webpack_public_path__ + "cd92968e49f0dddc79464371083f53ad.svg";